export function validateDocumentFile(
  file: Pick<File, "name" | "size" | "type">,
): "application/pdf" | "text/plain" {
  if (file.size < 1 || file.size > 10 * 1024 * 1024)
    throw new Error("Envie um arquivo entre 1 byte e 10 MB.");
  const extension = file.name.split(".").pop()?.toLowerCase();
  const mimeType =
    extension === "pdf" ? "application/pdf" : extension === "txt" ? "text/plain" : null;
  if (!mimeType || (file.type && file.type !== mimeType))
    throw new Error("Envie um PDF ou um TXT em UTF-8.");
  return mimeType;
}
